import React from 'react';
import loading from './res/loading.svg'

//todo separate file
export default function LoadingPage() {
    return <div className='loading'>
        <img src={loading} alt='loading'/>
    </div>
}